<template>
  <div>
    <button v-b-modal="'mf_login_modal'" id="mf_modal_login_btn">Login</button>
    <b-modal ok-only size="sm" hide-header ok-title="Fermer" id="mf_login_modal" centered>
      <div>
        <div class="inputGroup">
          <label for="inputEmail">email</label>
          <input type="email" id="inputEmail" placeholder="votre@email.com" />
        </div>
        <div class="inputGroup">
          <label for="inputPassword">password</label>
          <input type="password" id="inputPassword" placeholder="*********" />
        </div>
        <div>
          <button>Google Connect</button>
        </div>
        <div>
          <button>Back</button>
          <button>Login</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
#mf_modal_login_btn {
  border-radius: 5px;
  background: #9bbdf9;
  border: none;
  font-weight: bold;
  padding: 10px;
  padding-left: 15px;
  padding-right: 15px;
  margin-left: -5px;

  &:hover {
    background: $bg_color_bl;
  }

  span {
    position: relative;
    font-weight: bold;
    font-size: 30px !important;
    color: $mf_ft_color_white !important;
    top: -3px;
    right: 0px;
  }
}

#mf_register_securityModal {
  $margin: 40px;

  #mf_register_securityModal___BV_modal_content_ {
    background: #121212 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    padding: 20px;
    background: #1c1538;
  }

  #mf_register_securityModal___BV_modal_footer_ {
    border: none;

    button {
      background: $blue_color 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 41px;
      opacity: 1;
      border: none;
      width: 35%;
    }
  }

  .mf_register_securityModal_title {
    text-align: left;
    font: normal normal normal 30px/40px Segoe UI;
    letter-spacing: 0px;
    color: #ffffff;
    opacity: 1;
    margin-top: $margin;
  }

  .mf_register_securityModal_content {
    margin-top: $margin;
    text-align: left;
    font: normal normal normal 20px/27px Segoe UI;
    letter-spacing: 0px;
    color: #707070;
    opacity: 1;
  }
}
</style>
